<!-- we really need a existing model, especially for product titles (variants) -->
@if (fields().length > 0 && modelExists()) {
    <formly-form [model]="model" [fields]="fields()" [form]="form" [options]="options" />
}

@if (relatedCustomEntities()?.length > 0) {
    <p-tabs [(value)]="selectedCustomEntityTab">
        <p-tablist>
            @for (entity of relatedCustomEntities(); track $index) {
                <p-tab [value]="$index">{{ entity.tabLabel }}</p-tab>
            }
        </p-tablist>
        <p-tabpanels>
            <blockable-div [blocked]="!model?.id">
                @for (entity of relatedCustomEntities(); track $index) {
                    <p-tabpanel [value]="$index">
                        @defer (when selectedCustomEntityTab() == $index) {
                            <app-custom-entity-list-widget
                                [entityName]="entity.entityName"
                                [entity]="entity.entitySchema"
                                [silentDefaultModel]="entity.silentDefaultModel()"
                                [silentSearchRules]="entity.silentSearchRules()"
                            />
                        }
                    </p-tabpanel>
                }
            </blockable-div>
        </p-tabpanels>
    </p-tabs>
}
